import { Link } from 'react-router-dom'
import { Lock, Sparkles } from 'lucide-react'
import { useAuthStore } from '../../store/authStore'
import { PAGE_REGISTRY_BY_KEY } from '../../lib/permissions/pageRegistry'

interface UpgradePromptProps {
  pageKey?: string
  feature?: string
  className?: string
}

export function UpgradePrompt({ pageKey, feature, className }: UpgradePromptProps) {
  const { tenant } = useAuthStore()
  const entry = pageKey ? PAGE_REGISTRY_BY_KEY[pageKey] : undefined
  const label = entry?.label ?? feature
  const planName = tenant?.plan ?? 'your current plan'

  return (
    <div className={`flex flex-col items-center justify-center py-20 px-4 text-center ${className ?? ''}`}>
      <div className="h-14 w-14 rounded-2xl bg-brand-50 flex items-center justify-center mb-4">
        <Lock className="h-7 w-7 text-brand-500" />
      </div>
      <h1 className="text-lg font-semibold text-slate-900 mb-1">
        {label ? `${label} isn't included in your plan` : "This feature isn't included in your plan"}
      </h1>
      <p className="text-sm text-slate-500 max-w-md">
        Your <span className="font-medium capitalize text-slate-700">{planName}</span> plan
        doesn&apos;t include access to this page. Upgrade to unlock it.
      </p>
      <Link
        to="/subscription"
        className="btn-primary mt-6 inline-flex items-center gap-1.5"
      >
        <Sparkles className="h-4 w-4" />
        View Plans
      </Link>
    </div>
  )
}
